import { DialogContent as MuiDialogContent } from '@mui/material';

export const DialogContent = MuiDialogContent;
